import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";

export default function useSendParticipantPin() {
  const { write, ...rest } = useApiWrite();

  const sendParticipantPin = (email: string): Promise<string> =>
    write<string>({
      url: endpoints.sendParticipantPin(),
      method: HTTP_METHOD.POST,
      data: { email: email },
    }).then(({ data }) => data);

  return { sendParticipantPin, ...rest };
}
